export class Accessor {
    /**
     * @param object
     * @param attribute
     * @return
     */
    getValue(object, attribute) {
        return object[attribute.name];
    }
    /**
     * @param object
     * @param attribute
     * @param value
     */
    setValue(object, attribute, value) {
        // eslint-disable-next-line no-param-reassign
        object[attribute.name] = value;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWNjZXNzb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJBY2Nlc3Nvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQSxNQUFNLE9BQU8sUUFBUTtJQUNuQjs7OztPQUlHO0lBQ0gsUUFBUSxDQUFJLE1BQWUsRUFBRSxTQUF1QjtRQUNsRCxPQUFPLE1BQU0sQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFhLENBQUM7SUFDNUMsQ0FBQztJQUVEOzs7O09BSUc7SUFDSCxRQUFRLENBQUksTUFBZSxFQUFFLFNBQXVCLEVBQUUsS0FBUTtRQUM1RCw2Q0FBNkM7UUFDN0MsTUFBTSxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsR0FBRyxLQUFLLENBQUM7SUFDakMsQ0FBQztDQUNGIn0=